// extracted by mini-css-extract-plugin
module.exports = {"noData":"EmptyList_noData__1Bt0r","btn":"EmptyList_btn__3-IVF"};